/*
 * Parallaxe horizontal du Slider Banner.
 * Se branche sur l'instance Swiper créée par sliderBanner.bundle.js (el.swiper).
 * - fond (.slider-banner__bg) : défile plus lentement que la slide
 * - texte (.slider-banner__fg) : défile plus vite et s'estompe
 * Voir docs/slider-banner-parallaxe.md
 */
(function () {
  'use strict';

  var BG_FACTOR = 0.3;    // part du déplacement compensée par le fond (0 = pas d'effet)
  var FG_FACTOR = 0.15;   // avance supplémentaire du texte
  var FG_FADE = 1.4;      // vitesse d'estompage du texte
  var SPEED = 1000;       // durée de transition entre slides (ms)

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setTranslate(swiper) {
    var width = swiper.width;
    if (!width) return;

    for (var i = 0; i < swiper.slides.length; i++) {
      var slide = swiper.slides[i];
      // Position de la slide dans le viewport, en largeurs de slide : 0 = active, -1 = à gauche, 1 = à droite
      var x = (swiper.translate + swiper.slidesGrid[i]) / width;
      x = Math.max(-1, Math.min(1, x));

      var bg = slide.querySelector('.slider-banner__bg');
      var fg = slide.querySelector('.slider-banner__fg');

      if (bg) bg.style.transform = 'translate3d(' + (-x * BG_FACTOR * 100) + '%,0,0)';
      if (fg) {
        fg.style.transform = 'translate3d(' + (x * FG_FACTOR * 100) + '%,0,0)';
        fg.style.opacity = Math.max(0, 1 - Math.abs(x) * FG_FADE);
      }
    }
  }

  function setTransition(swiper, duration) {
    for (var i = 0; i < swiper.slides.length; i++) {
      var layers = swiper.slides[i].querySelectorAll('.slider-banner__bg, .slider-banner__fg');
      for (var j = 0; j < layers.length; j++) {
        layers[j].style.transitionDuration = duration + 'ms';
      }
    }
  }

  function attach(el) {
    var swiper = el.swiper;
    if (!swiper || el.dataset.parallax === 'on' || reducedMotion.matches) return;
    el.dataset.parallax = 'on';

    swiper.params.speed = SPEED;
    swiper.on('setTranslate', function () { setTranslate(swiper); });
    swiper.on('setTransition', function (s, duration) { setTransition(swiper, duration); });
    swiper.on('resize', function () { setTranslate(swiper); });

    setTransition(swiper, 0);
    setTranslate(swiper);
  }

  function init(root) {
    var sliders = (root || document).querySelectorAll('slider-banner-kercambre[data-swiper]');
    for (var i = 0; i < sliders.length; i++) attach(sliders[i]);
  }

  customElements.whenDefined('slider-banner-kercambre').then(function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
